/* Core & libraries */
import React, { useEffect, useState } from 'react';
import { useTheme } from 'react-jss';
import { FormattedMessage } from 'react-intl';

/* Helpers, constants, custom methods, internal libraries */
import { useUserContext } from '../../../contexts/userContext';

/* Components */
import UCModal from '../../ucmodal';
import Content from './content';
import { ReactComponent as MailSvg } from '../../../resources/images/mail-icon.svg';
import { useGlobalContext, useGlobalUpdateContext } from '../../../contexts/globalContext';

/* Styles */
import styles from './styles';
import { storageFactory } from 'factory/storageFactory';

const localStore = storageFactory(() => localStorage);
const sessionStore = storageFactory(() => sessionStorage);

const InviteAuthorisedModal = () => {
  const theme = useTheme();
  const classes = styles({ theme });

  const globalProperties = useGlobalContext();
  const setGlobalProperties = useGlobalUpdateContext();
  const userContext = useUserContext();
  const [showModal, setShowModal] = useState(false);
  const preferencesModalSaved = sessionStore.getItem('preferencesModalSaved');
  const companyEntityId = userContext?.userInfo?.companyInfo?.companyEntityId;

  useEffect(() => {
    const showShellUsersModal = userContext?.userInfo?.showShellUsersModal;
    if (!showShellUsersModal) return;
    const shouldShow = localStore.getItem('showAuthorisedCityUsersModal') === 'true';
    setShowModal(shouldShow);
    setGlobalProperties((prev) => ({
      ...prev,
      showIncompleteBanner: true,
      inviteAuthorisedModal: {
        ...prev?.inviteAuthorisedModal,
        showInviteAuthorisedModal: shouldShow,
      },
    }));
  }, [userContext?.userInfo?.showShellUsersModal]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (globalProperties?.inviteAuthorisedModal?.showInviteAuthorisedModal === true) {
      setShowModal(true);
    }
  }, [globalProperties?.inviteAuthorisedModal?.showInviteAuthorisedModal]);

  // Handle modal close properly
  const handleCloseModal = (status) => {
    setShowModal(status);
    setGlobalProperties((prev) => ({
      ...prev,
      inviteAuthorisedModal: {
        ...prev?.inviteAuthorisedModal,
        showInviteAuthorisedModal: status,
      },
    }));
    if (!status) {
      localStore.setItem('showAuthorisedCityUsersModal', 'false');
    }
  };

  const AuthorisedUsersModal = () => {
    return (
      <UCModal
        className={classes.inviteAuthorisedModal}
        showModal={showModal}
        setShowModal={handleCloseModal}
        modalIcon={<MailSvg />}
        modalTitle={<FormattedMessage id="inviteauthorisedmodal.title" />}
        modalDescription={<FormattedMessage id="inviteauthorisedmodal.description" />}
        modalContent={<Content setShowModal={handleCloseModal} companyEntityId={companyEntityId} />}
        dataTestId="inviteAuthorisedModal"
        onExited={() => handleCloseModal(false)}
      />
    );
  };

  const showPrefModal = userContext?.userInfo?.showPreferencesModal;
  const showAddEmailModal = userContext?.userInfo?.mustChangeEmailAddress;
  const showEmailMissingATM = userContext?.userInfo?.primaryATMSetupObligatory;

  const determineAuModalView = () => {
    if (!showPrefModal && !showAddEmailModal && !showEmailMissingATM) {
      {
        /* if pref modal is not to be shown (only on first login) just display the AU modal */
      }
      return AuthorisedUsersModal();
    } else if (
      showPrefModal &&
      preferencesModalSaved &&
      !showAddEmailModal &&
      !showEmailMissingATM
    ) {
      {
        /* show the AU modal only after preferences are saved (preferences modal is closed) */
      }
      return AuthorisedUsersModal();
    } else {
      return null;
    }
  };

  return <>{determineAuModalView()}</>;
};

export default InviteAuthorisedModal;
